const windowHeight = window.innerHeight;
const miniCart = document.querySelector('.mini-cart');
const miniCartWrapper = miniCart.querySelector('.cart-wrapper');

miniCartWrapper.style.maxHeight = `${windowHeight - (miniCart.getBoundingClientRect().top * 3)}px`;
